"use client";

import { useEffect, useState } from "react";
import BrandSections from "./BrandSections";
export default function BrandSectionsLoader({
  brandSlug
}) {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    async function fetchSections() {
      if (!brandSlug) return;
      try {
        const res = await fetch(`/api/brandsections/${brandSlug}`);
        const data = await res.json();
        setSections(data?.sections || []);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
    fetchSections();
  }, [brandSlug]);
  if (loading) {
    return null;
  }
  if (!sections?.length) {
    return null;
  }
  return <BrandSections sections={sections} />;
}